//certifications

//   http://dev-hydronew.azurewebsites.net/api/Help/Api/GET-api-Patron-GetAllActivity_LocationId

export const GetAllLogReadings = (locationid) => {
  return $.get('LogTemplate/GetAllLogReadings?IsCustom=null&IsActive=true')
}
export const GetAllLogTasks = (locationid) => {
  return $.get('LogTemplate/GetAllLogTasks?IsCustom=null&IsActive=true')
}
export const GetAllLogMaintenance = (locationid) => {
  return $.get('LogTemplate/GetAllLogMaintenance?IsCustom=null&IsActive=true')
}
export const GetPools = (locationid) => {
  return $.get('Pool/GetPools?locationId=' + locationid)
}
export const AddLogTemplate = (model) => {
  return $.post('LogTemplate/AddLogTemplate', model)
}
export const UpdateLogTemplate = (model) => {
  return $.ajax({
    url: 'LogTemplate/UpdateLogTemplate',
    data: JSON.stringify(model),
    contentType: 'application/json',
    cache: false,
    type: 'POST'
  })
}
export const GetLocations = () => {
  let havingPools = true
  return $.get('Location/GetLocations?havingPools=' + havingPools)
}
export const GetLogTemplateById = (id) => {
  return $.get('LogTemplate/GetLogTemplateWRTPoolsById?Id=' + id)
}
export const GetRangeValue = (OrganizationId) => {
  return $.get('LogTemplate/GetAllLogReadings?IsCustom=false&IsActive=true&OrganizationId=' + OrganizationId)
}
/********************************************************************
export const UpdateActivity = (model) => {
  return $.post('Patron/UpdateActivity', model)
}
export const DeleteActivity = (ActivityId) => {
  return $.post('Patron/DeleteActivity?ActivityId=' + ActivityId)
}
export const GetActivityDetails = (ActivityId) => {
  return $.get('Patron/GetActivityDetails?ActivityId=' + ActivityId)
}
*********************************************************************/


// WEBPACK FOOTER //
// ./src/components/ReadingsMaintenance/readings_maintenance.service.js